import Vue from 'vue'
import {post,GETID} from "../config/server";


//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$userId = GETID();

const API = {
    userOrchard:"biz/userOrchard",
    userFriendReceiveAwards:'biz/userFriendReceiveAwards', //领取奖励 userId,otherId,taskId
    searchUserFriendList:'biz/searchUserFriendList',// 好友列表 userId
    fillUserPhone:'biz/fillUserPhone', //手机号邀请 userId,userPhone
    fillInvitationCode:'biz/fillInvitationCode',//userId,invitationCode
    searchUserInvitationCode:'biz/searchUserInvitationCode', //参数 userId,返回invitationCode，user：1新用户，2老用户
    newPeopleWelfare:'biz/newPeopleWelfare',//新用户福利 参数 userId
    receiveNewPeopleWelfare:'biz/receiveNewPeopleWelfare',//新用户福利领取 type;//1:优惠券，2:每日碎纸，3:新人任务
    oldUsersReturn:'biz/oldUsersReturn',
    searchUserCrytal:'biz/searchUserCrytal',
    paperConsultation:'biz/paperConsultation'
};
  
  
export default API;

Vue.prototype.$url = API;


// WEBPACK FOOTER //
// ./src/api/index.js